import PeopleRouteStore from './schema/PeopleRouteStore';
import PeopleRouteType from './schema/PeopleRouteType';
import { createStore } from 'satcheljs';

const defaultPeopleRouteStore: PeopleRouteStore = {
    location: PeopleRouteType.Default,
    folderId: null,
    subLocation: null,
    subLocationOption: null,
};

const getPeopleRouteStore = createStore<PeopleRouteStore>(
    'PeopleRouteStore',
    defaultPeopleRouteStore
);
const store = getPeopleRouteStore();

export default store;
